var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "id": "bigdata",
            "title": "Solution",
            "src": "/images/sub/subvisual-solution.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first",
    scopedSlots: _vm._u([{
      key: "titleLine",
      fn: function fn() {
        return [_vm._v(" AI Big Data ")];
      },
      proxy: true
    }])
  }, [_c('tit-wrap-large', {
    staticClass: "mb-0",
    scopedSlots: _vm._u([{
      key: "text",
      fn: function fn() {
        return [_vm._v("As IReis’s differentiating point, root zone data provides innovative ideas and solutions in agriculture.")];
      },
      proxy: true
    }])
  }, [_c('b', [_vm._v("AI & Big Data Based Agriculture")]), _vm._v(" "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v("It leads you to easier, more systematic future agriculture. ")])], 1), _c('page-section', {
    staticClass: "d-flex align-center min-h-lg-980px"
  }, [_c('div', {
    staticClass: "page-section__bg",
    staticStyle: {
      "background-image": "url(/images/sub/solution/bigdata/bigdata-bg.jpg)"
    }
  }), _c('div', {
    attrs: {
      "data-aos": "fade",
      "data-aos-delay": "100"
    }
  }, [_c('v-divider', {
    staticStyle: {
      "border-color": "rgba(255,255,255,0.2)"
    }
  }), _c('div', {
    staticClass: "py-20px py-md-40px py-xl-80px text-center"
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--sm white--text"
  }, [_c('h4', {
    staticClass: "tit tit--lg"
  }, [_vm._v("AI Big Data suggesting a sustainable future agriculture")])]), _c('div', {
    staticClass: "txt txt--xl white--text"
  }, [_vm._v("IReis provides agricultural recipes optimized for the crop production environment by collecting and analyzing daily over "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v("200 million cases of data obtained from farms. We suggest a variety of data-based agricultural solutions to future food shortages that may result from population growth, climate change, water shortages, etc.")])]), _c('v-divider', {
    staticStyle: {
      "border-color": "rgba(255,255,255,0.2)"
    }
  })], 1)]), _c('page-section-image', {
    attrs: {
      "imageSrc": "/images/sub/solution/bigdata/bigdata-img.jpg",
      "reverse": ""
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "tit tit--lg letter-spacing-n04"
        }, [_vm._v("AI and big data-based root zone solution that suggests easier agriculture")])];
      },
      proxy: true
    }, {
      key: "text",
      fn: function fn() {
        return [_vm._v(" Root zone information is significant and differentiated data in agriculture. Our system diagnoses issues of the cultivation environment and provides farmers with a decision-making dashboard concerning the recognition of and solution to the state of crops based on data, enabling them to predict and respond to different agricultural variables. ")];
      },
      proxy: true
    }])
  }), _c('page-section-image', {
    staticClass: "page-section--last",
    attrs: {
      "imageSrc": "/images/sub/solution/bigdata/bigdata-img2.jpg"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "tit tit--lg"
        }, [_vm._v("Operation of useful and accurate data-based smart farms")])];
      },
      proxy: true
    }, {
      key: "text",
      fn: function fn() {
        return [_vm._v(" Our system optimizes the growth and yield of your crops by monitoring the growth conditions of the crops based on our root zone data accumulated over ten years Data-based agriculture helps farmers cultivate crops in a smarter way. ")];
      },
      proxy: true
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }